// 직업 가치관 문항 데이터
// 각 가치별 12문항 × 6가치 = 72문항, 0~10점 척도
// 같은 개념을 서로 다른 표현으로 3번씩 물어(병렬 문항) 응답 일관성을 측정한다.
// groupId가 같은 문항끼리 내용이 사실상 같다.

export type ValueTypeKey =
  | 'achievement'
  | 'helping'
  | 'creativity'
  | 'intellectual'
  | 'leadership'
  | 'stability';

export interface ValueQuestion {
  id: string;
  type: ValueTypeKey;
  groupId: string;
  statement: string;
}

export const valueQuestions: ValueQuestion[] = [
  // === 성취감 (achievement) ===
  { id: 'v01', type: 'achievement', groupId: 'ac1', statement: '어려운 목표를 달성했을 때 큰 성취감을 느낀다' },
  { id: 'v02', type: 'achievement', groupId: 'ac1', statement: '힘든 목표를 이뤄냈을 때 큰 보람을 느낀다' },
  { id: 'v03', type: 'achievement', groupId: 'ac1', statement: '어려운 일을 해내고 성취감을 느끼는 것이 중요하다' },

  { id: 'v04', type: 'achievement', groupId: 'ac2', statement: '도전적인 과제를 해내는 것을 중요하게 생각한다' },
  { id: 'v05', type: 'achievement', groupId: 'ac2', statement: '어려운 도전에 맞서 이겨내는 것을 중요시한다' },
  { id: 'v06', type: 'achievement', groupId: 'ac2', statement: '쉬운 일보다 도전적인 과제에 끌린다' },

  { id: 'v07', type: 'achievement', groupId: 'ac3', statement: '내 능력과 성과를 인정받는 것이 나에게 중요하다' },
  { id: 'v08', type: 'achievement', groupId: 'ac3', statement: '내가 이룬 성과를 사람들이 알아주길 바란다' },
  { id: 'v09', type: 'achievement', groupId: 'ac3', statement: '내 실력과 성과를 인정받는 데 큰 의미를 둔다' },

  { id: 'v10', type: 'achievement', groupId: 'ac4', statement: '한계에 도전하며 계속 성장하고 싶다' },
  { id: 'v11', type: 'achievement', groupId: 'ac4', statement: '내 한계를 넘어 꾸준히 성장하고 싶다' },
  { id: 'v12', type: 'achievement', groupId: 'ac4', statement: '스스로의 한계를 깨고 더 성장하는 것을 원한다' },

  // === 사회공헌 (helping) ===
  { id: 'v13', type: 'helping', groupId: 'hp1', statement: '다른 사람의 삶을 개선하는 일에 큰 가치를 둔다' },
  { id: 'v14', type: 'helping', groupId: 'hp1', statement: '누군가의 삶을 더 나아지게 돕는 일을 중요하게 여긴다' },
  { id: 'v15', type: 'helping', groupId: 'hp1', statement: '사람들의 삶을 좋은 방향으로 바꾸는 일에 보람을 느낀다' },

  { id: 'v16', type: 'helping', groupId: 'hp2', statement: '사회적 약자를 돕는 일이 의미 있다고 느낀다' },
  { id: 'v17', type: 'helping', groupId: 'hp2', statement: '도움이 필요한 이웃을 돕는 일을 소중히 여긴다' },
  { id: 'v18', type: 'helping', groupId: 'hp2', statement: '어려운 처지의 사람들을 돕는 데 큰 의미를 느낀다' },

  { id: 'v19', type: 'helping', groupId: 'hp3', statement: '내 일이 누군가에게 직접 도움이 되기를 바란다' },
  { id: 'v20', type: 'helping', groupId: 'hp3', statement: '내가 하는 일이 누군가에게 실질적 도움이 되길 원한다' },
  { id: 'v21', type: 'helping', groupId: 'hp3', statement: '내 노력이 다른 사람에게 직접 전달되길 바란다' },

  { id: 'v22', type: 'helping', groupId: 'hp4', statement: '사회에 기여하는 의미 있는 삶을 살고 싶다' },
  { id: 'v23', type: 'helping', groupId: 'hp4', statement: '사회 발전에 이바지하는 삶을 살고 싶다' },
  { id: 'v24', type: 'helping', groupId: 'hp4', statement: '세상을 더 나은 곳으로 만드는 데 기여하고 싶다' },

  // === 창의·표현 (creativity) ===
  { id: 'v25', type: 'creativity', groupId: 'cr1', statement: '세상에 없던 새로운 것을 만들어내는 것이 중요하다' },
  { id: 'v26', type: 'creativity', groupId: 'cr1', statement: '이전에 없던 새로운 것을 창조하는 데 가치를 둔다' },
  { id: 'v27', type: 'creativity', groupId: 'cr1', statement: '남이 안 만든 새로운 것을 만들어내고 싶다' },

  { id: 'v28', type: 'creativity', groupId: 'cr2', statement: '나만의 개성과 독창성을 표현하고 싶다' },
  { id: 'v29', type: 'creativity', groupId: 'cr2', statement: '내 개성을 드러내고 독창적으로 표현하고 싶다' },
  { id: 'v30', type: 'creativity', groupId: 'cr2', statement: '나다움을 살려 독특하게 표현하는 것을 중요시한다' },

  { id: 'v31', type: 'creativity', groupId: 'cr3', statement: '창의적인 결과물을 만드는 일에서 보람을 느낀다' },
  { id: 'v32', type: 'creativity', groupId: 'cr3', statement: '창의적인 작품이나 결과를 만들어내는 데 보람을 느낀다' },
  { id: 'v33', type: 'creativity', groupId: 'cr3', statement: '독창적인 결과물을 완성했을 때 큰 만족을 느낀다' },

  { id: 'v34', type: 'creativity', groupId: 'cr4', statement: '정해진 틀보다 자유로운 표현을 더 가치 있게 여긴다' },
  { id: 'v35', type: 'creativity', groupId: 'cr4', statement: '틀에 얽매이지 않고 자유롭게 표현하는 것을 중요시한다' },
  { id: 'v36', type: 'creativity', groupId: 'cr4', statement: '정해진 방식보다 자유로운 표현을 더 선호한다' },

  // === 지적 탐구 (intellectual) ===
  { id: 'v37', type: 'intellectual', groupId: 'it1', statement: '새로운 지식을 배우고 이해하는 것에 큰 가치를 둔다' },
  { id: 'v38', type: 'intellectual', groupId: 'it1', statement: '새로운 것을 배우고 깨닫는 일을 소중히 여긴다' },
  { id: 'v39', type: 'intellectual', groupId: 'it1', statement: '새 지식을 얻고 이해하는 것을 중요하게 생각한다' },

  { id: 'v40', type: 'intellectual', groupId: 'it2', statement: '진리를 탐구하고 깊이 연구하는 삶이 의미 있다' },
  { id: 'v41', type: 'intellectual', groupId: 'it2', statement: '진리를 좇아 깊이 탐구하는 삶을 살고 싶다' },
  { id: 'v42', type: 'intellectual', groupId: 'it2', statement: '깊이 연구하며 진리를 찾는 삶에 의미를 느낀다' },

  { id: 'v43', type: 'intellectual', groupId: 'it3', statement: '지적 호기심을 채우는 일이 나에게 중요하다' },
  { id: 'v44', type: 'intellectual', groupId: 'it3', statement: '궁금증을 해결하고 지적 호기심을 충족시키는 것을 중요시한다' },
  { id: 'v45', type: 'intellectual', groupId: 'it3', statement: '알고 싶은 욕구를 채우는 것이 나에게 중요하다' },

  { id: 'v46', type: 'intellectual', groupId: 'it4', statement: '복잡한 문제를 이해하고 설명할 수 있게 되는 것을 좋아한다' },
  { id: 'v47', type: 'intellectual', groupId: 'it4', statement: '어려운 문제를 이해해 남에게 설명할 수 있게 되는 것이 좋다' },
  { id: 'v48', type: 'intellectual', groupId: 'it4', statement: '복잡한 내용을 깨우쳐 설명해내는 것에 즐거움을 느낀다' },

  // === 영향력 (leadership) ===
  { id: 'v49', type: 'leadership', groupId: 'ld1', statement: '조직이나 사회에 큰 영향력을 미치고 싶다' },
  { id: 'v50', type: 'leadership', groupId: 'ld1', statement: '세상에 큰 영향력을 행사하고 싶다' },
  { id: 'v51', type: 'leadership', groupId: 'ld1', statement: '조직과 사회에 의미 있는 영향력을 끼치고 싶다' },

  { id: 'v52', type: 'leadership', groupId: 'ld2', statement: '팀을 이끌고 변화를 만들어내는 것을 중요하게 생각한다' },
  { id: 'v53', type: 'leadership', groupId: 'ld2', statement: '조직을 이끌며 새로운 변화를 만들어내고 싶다' },
  { id: 'v54', type: 'leadership', groupId: 'ld2', statement: '팀을 이끌어 긍정적인 변화를 이끌어내는 데 가치를 둔다' },

  { id: 'v55', type: 'leadership', groupId: 'ld3', statement: '내 비전과 의견으로 사람들을 움직이고 싶다' },
  { id: 'v56', type: 'leadership', groupId: 'ld3', statement: '내 뜻과 비전으로 사람들을 이끌고 싶다' },
  { id: 'v57', type: 'leadership', groupId: 'ld3', statement: '내 생각으로 사람들을 감동시키고 움직이게 하고 싶다' },

  { id: 'v58', type: 'leadership', groupId: 'ld4', statement: '더 큰 책임을 맡아 이끌어가는 것을 원한다' },
  { id: 'v59', type: 'leadership', groupId: 'ld4', statement: '책임 있는 자리에서 조직을 이끌고 싶다' },
  { id: 'v60', type: 'leadership', groupId: 'ld4', statement: '더 큰 책임을 지고 사람들을 이끌어가고 싶다' },

  // === 안정·전문성 (stability) ===
  { id: 'v61', type: 'stability', groupId: 'st1', statement: '안정적이고 예측 가능한 커리어가 나에게 중요하다' },
  { id: 'v62', type: 'stability', groupId: 'st1', statement: '안정적인 직업과 미래가 나에게 중요하다' },
  { id: 'v63', type: 'stability', groupId: 'st1', statement: '예측 가능하고 안정된 진로를 중요하게 생각한다' },

  { id: 'v64', type: 'stability', groupId: 'st2', statement: '한 분야에서 전문성을 깊이 쌓아 인정받고 싶다' },
  { id: 'v65', type: 'stability', groupId: 'st2', statement: '한 분야의 전문가로 깊이 성장해 인정받고 싶다' },
  { id: 'v66', type: 'stability', groupId: 'st2', statement: '특정 분야에서 깊은 전문성을 키워 전문가가 되고 싶다' },

  { id: 'v67', type: 'stability', groupId: 'st3', statement: '체계적인 환경에서 꾸준히 성장하고 싶다' },
  { id: 'v68', type: 'stability', groupId: 'st3', statement: '정돈된 환경에서 착실히 성장하고 싶다' },
  { id: 'v69', type: 'stability', groupId: 'st3', statement: '체계가 잡힌 곳에서 안정적으로 성장하고 싶다' },

  { id: 'v70', type: 'stability', groupId: 'st4', statement: '생활의 안정과 균형을 중요하게 생각한다' },
  { id: 'v71', type: 'stability', groupId: 'st4', statement: '안정된 생활과 일과 삶의 균형을 소중히 여긴다' },
  { id: 'v72', type: 'stability', groupId: 'st4', statement: '안정적인 생활과 균형 잡힌 삶을 중요시한다' },
];